/* SuperHoodie redesign – home page interactions (hero design picker, tabbed product rows). */
(function () {
  if (window.__shHomeInit) return;
  window.__shHomeInit = true;

  /* Animated headline word ("Your dog / cat / face … on a hoodie."). Stops for good once a design chip is picked. */
  function initRotor(root) {
    var rotor = root.querySelector('[data-sh-rotor]');
    if (!rotor || rotor.__shRotor) return;
    var wordEl = rotor.querySelector('[data-sh-rotor-word]');
    var words = (rotor.getAttribute('data-words') || '').split('|').filter(Boolean);
    var interval = parseInt(rotor.getAttribute('data-interval'), 10) || 2500;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var index = Math.max(0, words.indexOf(wordEl.textContent.trim()));
    var timer = null, locked = false;

    function swap(word) {
      if (wordEl.textContent === word) return;
      if (reduce) { wordEl.textContent = word; return; }
      wordEl.classList.remove('is-in');
      wordEl.classList.add('is-out');
      setTimeout(function () {
        wordEl.textContent = word;
        wordEl.classList.remove('is-out');
        void wordEl.offsetWidth;
        wordEl.classList.add('is-in');
      }, 280);
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function start() {
      stop();
      if (locked || reduce || document.hidden || words.length < 2) return;
      timer = setInterval(function () { index = (index + 1) % words.length; swap(words[index]); }, interval);
    }
    rotor.__shRotor = {
      set: function (word) { locked = true; stop(); if (word) swap(word); }
    };
    document.addEventListener('visibilitychange', start);
    start();
  }

  function initHero(root) {
    initRotor(root);
    var chips = root.querySelectorAll('[data-sh-hero-chip]');
    if (!chips.length) return;
    var headline = root.querySelector('[data-sh-hero-headline]');
    var note = root.querySelector('[data-sh-hero-note]');
    var label = root.querySelector('[data-sh-hero-label]');
    var title = root.querySelector('[data-sh-hero-title]');
    var cta = root.querySelector('[data-sh-hero-cta]');

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        var id = chip.getAttribute('data-sh-hero-chip');
        chips.forEach(function (c) { c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'); });
        root.querySelectorAll('[data-sh-hero-img]').forEach(function (el) {
          el.hidden = el.getAttribute('data-sh-hero-img') !== id;
        });
        root.querySelectorAll('[data-sh-hero-price]').forEach(function (el) {
          el.hidden = el.getAttribute('data-sh-hero-price') !== id;
        });
        var rotorEl = root.querySelector('[data-sh-rotor]');
        if (rotorEl && rotorEl.__shRotor) {
          rotorEl.__shRotor.set(chip.getAttribute('data-word'));
        } else if (headline) {
          headline.textContent = chip.getAttribute('data-headline');
        }
        if (note) { note.textContent = chip.getAttribute('data-note'); note.hidden = !note.textContent; }
        var media = root.querySelector('[data-sh-hero-media]');
        if (media) media.classList.remove('is-intro');
        if (label) label.textContent = chip.getAttribute('data-label');
        if (title) title.textContent = chip.getAttribute('data-title');
        if (cta && chip.getAttribute('data-url')) cta.setAttribute('href', chip.getAttribute('data-url'));
      });
    });
  }

  function initTabs(root) {
    var tabs = root.querySelectorAll('[data-sh-tab]');
    if (!tabs.length) return;
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var id = tab.getAttribute('data-sh-tab');
        tabs.forEach(function (t) { t.setAttribute('aria-pressed', t === tab ? 'true' : 'false'); });
        root.querySelectorAll('[data-sh-tabpanel]').forEach(function (p) {
          p.hidden = p.getAttribute('data-sh-tabpanel') !== id;
        });
        root.querySelectorAll('[data-sh-tablink]').forEach(function (l) {
          l.hidden = l.getAttribute('data-sh-tablink') !== id;
        });
      });
    });
  }

  /* Rotating review card in the hero: pauses on hover/focus and via the pause button,
     never auto-rotates when the visitor prefers reduced motion. */
  function initReviews(root) {
    if (root.__shReviews) return;
    root.__shReviews = true;
    var slides = root.querySelectorAll('[data-sh-review-slide]');
    var btn = root.querySelector('[data-sh-review-pause]');
    if (slides.length < 2) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var interval = parseInt(root.getAttribute('data-interval'), 10) || 5000;
    var index = 0, timer = null, hovered = false, focused = false, paused = reduce;

    function show(i) {
      index = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) { s.hidden = n !== index; });
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function start() {
      stop();
      if (paused || hovered || focused || document.hidden) return;
      timer = setInterval(function () { show(index + 1); }, interval);
    }
    if (btn) {
      if (reduce) { btn.setAttribute('aria-pressed', 'true'); btn.setAttribute('aria-label', 'Play reviews'); }
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        paused = !paused;
        btn.setAttribute('aria-pressed', paused ? 'true' : 'false');
        btn.setAttribute('aria-label', paused ? 'Play reviews' : 'Pause reviews');
        if (!paused) show(index + 1);
        start();
      });
    }
    root.addEventListener('mouseenter', function () { hovered = true; stop(); });
    root.addEventListener('mouseleave', function () { hovered = false; start(); });
    root.addEventListener('focusin', function () { focused = true; stop(); });
    root.addEventListener('focusout', function () { focused = false; start(); });
    document.addEventListener('visibilitychange', start);
    start();
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-sh-reviews]').forEach(initReviews);
    (scope || document).querySelectorAll('[data-sh-hero]').forEach(initHero);
    (scope || document).querySelectorAll('[data-sh-tabs]').forEach(initTabs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  /* Re-initialise when a section is re-rendered in the theme editor */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
